<script setup lang="ts">
import UserCreateForm from "@/components/user-create-form.vue";
import { Role } from "@/models/enums/role";
import { RouteName } from "@/router";
import { useRouter } from "vue-router";

const router = useRouter();
defineProps<{ customerNumber: string }>();

async function onCreate() {
  await router.push({ name: RouteName.CustomerService });
}
</script>

<template>
  <section class="section px-0">
    <p class="title is-4">Skapa kundtjänstadministratör</p>

    <div class="columns">
      <div class="column is-6">
        <user-create-form
          :customer-number="customerNumber"
          :role="Role.ONE_USER_ADMIN"
          @create="onCreate"
        ></user-create-form>
      </div>
    </div>
  </section>
</template>
